import React, { Fragment, useState, useEffect } from "react"
import { Portal } from "./portal"
import { Panel } from "./first"
import { Advert } from "./advert"
// import { mainMenuTree } from "./var"
import cx from "classnames"
import { Second } from "./second"
import { useOvermind } from "../overmind"

export const Menu = () => {
  const { state, actions } = useOvermind()

  return (
    <Fragment>
      {state.menu.isVisibleFirstPanel ? (
        <div
          className="menuButton menuButtonActive"
          onClick={() => {
            actions.menu.setFirstPanelHidden()
          }}>
          <span className="menuButtonText">Закрыть</span>
          <div className="menuButtonToggle">
            <div className="menuButtonToggleInner" />
          </div>
        </div>
      ) : (
        <button
          className="menuButton"
          onClick={() => {
            actions.menu.setFirstPanelVisible()
          }}>
          <span className="menuButtonText">Меню</span>
          <div className="menuButtonToggle">
            <div className="menuButtonToggleInner" />
          </div>
        </button>
      )}
      <Portal onClose={actions.menu.setFirstPanelHidden}>
        {state.menu.data && (
          <div className={cx("menu", { menuOverlay: state.menu.isVisibleFirstPanel })}>
            <Panel key="panel" />
            <div className="menuRight">
              {state.menu.adverts.isLoad && <Advert />}
              <Second />
            </div>
          </div>
        )}
      </Portal>
    </Fragment>
  )
}
